import { render, staticRenderFns } from "./UploadRequestInfo.vue?vue&type=template&id=210b9db6"
import script from "./UploadRequestInfo.vue?vue&type=script&lang=js"
export * from "./UploadRequestInfo.vue?vue&type=script&lang=js"
import style0 from "./UploadRequestInfo.vue?vue&type=style&index=0&id=210b9db6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports